module.exports.ALL_SCREENS = 'ALL_SCREENS';
